import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const DesignationForm = ({ designationId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;

     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     const [designationName, setDesignationName] = useState(initialData?.designation_type || "");

     useEffect(() => {
          setDesignationName(initialData?.designation_type || "");
     }, [initialData]);
     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!designationName.trim()) {
               setError('Designation name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (designationId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateUserDesignById/${designationId}`;
                    body = { designation: designationName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createUserDesign`;
                    body = { designation: designationName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(designationId ? 'Designation updated successfully' : 'Designation created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/designation');
               } else {
                    setError(data.message || `Failed to ${designationId ? 'update' : 'create'} PYAGROUP`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };

     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               {/* <h2 className="section-title mb-4">{designationId ? 'Edit Designation' : 'Add Designation'}</h2> */}
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="designationName"
                              placeholder=" "
                              autoComplete="off"
                              value={designationName}
                              onChange={(e) => setDesignationName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="designationName">Designation Name</label>
                    </div>
               </div>
               {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
               <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginTop: '15px' }}
                    disabled={loading}
               >
                    {loading ? 'Saving...' : 'Save'}
               </button>
          </form>
     );
};

export default DesignationForm;
